import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { slot } from './slot.vanilla.mjs';

const TagSlotImpl = forwardRef(
  ({ className: classNameFromProps, ...props }, forwardedRef) => {
    const className = classNames(slot, classNameFromProps);
    return /* @__PURE__ */ jsx(
      Primitive.div,
      {
        "data-scope": "tag",
        "data-part": "slot",
        className,
        ref: forwardedRef,
        ...props
      }
    );
  }
);
const TagSlot = styled(TagSlotImpl);
TagSlot.toString = () => '[data-scope="tag"][data-part="slot"]';

export { TagSlot };
//# sourceMappingURL=Slot.mjs.map
